/**
 * @generated SignedSource<<769ede5e5c8de9b056f95d58e7753207>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BookingStatus = "CONFIRMED" | "DRAFT";
export type DietaryTags = "ALCOHOL_FREE" | "ALLERGY" | "ALLIUM" | "CRUSTACEAN" | "DAIRY_FREE" | "DIABETIC" | "EGGS" | "FISH" | "GARLIC" | "GLUTEN_FREE" | "HAZELNUT" | "KOSHER" | "MILK" | "MUSHROOMS" | "NIGHTSHADE" | "NUTS" | "PALEO" | "PEANUTS" | "PESCATARIAN" | "PORK" | "POULTRY" | "PREGNANT" | "RED_MEAT" | "SALT" | "SEAFOOD" | "SHELLFISH" | "SHRIMP" | "SOY" | "SULFITES" | "TOMATOES" | "TREE_NUTS" | "VEGAN" | "VEGETARIAN" | "WALNUTS" | "WHEAT";
export type OccasionTags = "ANNIVERSARY" | "BIRTHDAY" | "BUSINESS_MEETING" | "CELEBRATION" | "CORPORATE_EVENT" | "GRADUATION" | "SPECIAL_EVENT";
import { FragmentRefs } from "relay-runtime";
export type DiningReservationSection_booking$data = {
  readonly canUpdate: boolean | null | undefined;
  readonly dietaryTags?: ReadonlyArray<DietaryTags> | null | undefined;
  readonly id: string;
  readonly notesFromMember?: string | null | undefined;
  readonly occasionTags?: ReadonlyArray<OccasionTags> | null | undefined;
  readonly ownerClient: {
    readonly __typename: "Customer";
    readonly id: string;
  } | {
    readonly __typename: "Member";
    readonly id: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly partySize?: number | null | undefined;
  readonly roomName?: string | null | undefined;
  readonly rounds: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly player: {
          readonly __typename: string;
          readonly firstName: string | null | undefined;
          readonly fullName: string;
          readonly id: string;
          readonly lastName: string | null | undefined;
          readonly profileImage: {
            readonly publicId: string;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly startSlot: {
    readonly agenda: {
      readonly date: string;
      readonly facility: {
        readonly minMaxGroupSize: {
          readonly max: number | null | undefined;
          readonly min: number | null | undefined;
        } | null | undefined;
        readonly name: string;
      };
    };
    readonly id: string;
  } | null | undefined;
  readonly status?: BookingStatus;
  readonly " $fragmentSpreads": FragmentRefs<"DiningAttendeesModal_booking">;
  readonly " $fragmentType": "DiningReservationSection_booking";
};
export type DiningReservationSection_booking$key = {
  readonly " $data"?: DiningReservationSection_booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"DiningReservationSection_booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v2 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DiningReservationSection_booking",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DiningAttendeesModal_booking"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "partySize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "roomName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dietaryTags",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "occasionTags",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "notesFromMember",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "type": "DiningBooking",
      "abstractKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canUpdate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "ownerClient",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "Member",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v2/*: any*/),
          "type": "Customer",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "date",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "bookingType",
                      "value": "STANDARD"
                    }
                  ],
                  "concreteType": "GroupSize",
                  "kind": "LinkedField",
                  "name": "minMaxGroupSize",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "min",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "max",
                      "storageKey": null
                    }
                  ],
                  "storageKey": "minMaxGroupSize(bookingType:\"STANDARD\")"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RoundConnection",
      "kind": "LinkedField",
      "name": "rounds",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoundEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "player",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fullName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Image",
                      "kind": "LinkedField",
                      "name": "profileImage",
                      "plural": false,
                      "selections": [
                        {
                          "alias": "publicId",
                          "args": null,
                          "kind": "ScalarField",
                          "name": "renderingKey",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "dbc02b8435c4078334711d29a2ee1007";

export default node;
